import React, { lazy } from 'react'
import { Navigate } from 'react-router-dom'

const OnBoarding = lazy(() => import('../pages/Common/OnBoarding'))

const Routes = [
  {
    path: '/onboarding',
    element: <OnBoarding />,
  },
  {
    path: '*',
    element: <Navigate to={'/onboarding'} replace />,
  },
]

export default Routes
